import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
      primary : {
        main: "#01336d",
        light: "#0081d4",
        contrastText: "#FFFFFF"
      },
      secondary: {
        light: "#FFFFFF",
        main: "#454442"
      },
      warning: {
        main: "#FFA500",
        dark: "#D19D00"
      }
    },
    typography: {
      button: {
        textTransform: "none",
      }
    }
  });

  export default theme
  